import Vue from "vue"
import {api} from "../resources"

export default {
    namespaced: true,
    state: {
        account_selected: null,
        transactions: {
            data: [],
            dirty: false,
            total_data: null,
            pagination: {
                current_page: null,
                pages: null
            }
        },
    },
    getters: {
        transactions: state => state.transactions.data,
        transactionsByDate: state => {
            const transactionsByDate = {}
            state.transactions.data.forEach(item => {
                const date = Vue.prototype.$moment.unix(item.date).startOf('day').format('DD-MM-YYYY');
                if (!transactionsByDate[date]) {
                    transactionsByDate[date] = []
                }
                transactionsByDate[date].push(item);
            })
            return transactionsByDate;
        }
    },
    actions: {
        async getRecentTransactions({commit, rootState, state}) {
            if (!state.transactions.data.length) {
                commit('setRecentTransactionsDirty');
            }
            commit('setPageRecentTransactions', 1);
            try {
                api.transactions.get({
                    space_id: rootState.space.current_space.data.id,
                    account_id: !!state.account_selected ? state.account_selected.id : '',
                    page: 1
                }).then(res => {
                    if (res.body.success) {
                        commit('setRecentTransactions', res.body);
                    } else {
                        console.log(res)
                    }
                });
            } catch (e) {
                console.log(e)
            }
        },
        async loadMoreRecentTransactions({commit, rootState, state}) {
            try {
                api.transactions.get({
                    space_id: rootState.space.current_space.data.id,
                    account_id: !!state.account_selected ? state.account_selected.id : '',
                    page: state.transactions.pagination.current_page
                }).then(res => {
                    if (res.body.success) {
                        commit('pushRecentTransactions', res.body);
                    } else {
                        console.log(res)
                    }
                });
            } catch (e) {
                console.log(e)
            }
        },
    },
    mutations: {
        setSelectedAcc(state, item) {
            state.account_selected = item;
        },
        setRecentTransactionsDirty(state) {
            state.transactions.dirty = true
        },
        setRecentTransactions(state, body) {
            state.transactions.total_data = {
                total: body.data.total,
                totalExpense: body.data.totalExpense,
                totalIncome: body.data.totalIncome,
                totalTransfers: body.data.totalTransfers
            };
            state.transactions.data = body.data.rows;
            state.transactions.pagination.pages = Math.ceil(body.data.length / 20);
            state.transactions.dirty = false;
        },
        pushRecentTransactions(state, body) {
            state.transactions.data.push(...body.data.rows)
        },
        setPageRecentTransactions(state, num) {
            state.transactions.pagination.current_page = num;
        },
        clearRecentTransactions(state) {
            state.transactions = {
                data: [],
                dirty: false,
                total_data: null,
                pagination: {
                    current_page: null,
                    pages: null
                }
            }
        }
    }
}
